import { FC } from 'react';
import { ReactComponent as SearchIcon } from '../../assets/images/search-normal.svg';
import { IconButton, InputAdornment, TextField } from '@mui/material';

interface InputTextSearchArgs {
  value: string;
  placeholder: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  iconPosition?: 'start' | 'end';
}

const InputTextSearch: FC<InputTextSearchArgs> = ({
  value,
  placeholder,
  onChange,
  iconPosition = 'start'
}) => {
  const adornment = (
    <InputAdornment position={iconPosition}>
      <IconButton edge={iconPosition}>{<SearchIcon />}</IconButton>
    </InputAdornment>
  );

  return (
    <TextField
      type="text"
      size="small"
      value={value}
      placeholder={placeholder}
      onChange={onChange}
      sx={style}
      InputProps={{
        [iconPosition === 'start' ? 'startAdornment' : 'endAdornment']: adornment
      }}
    />
  );
};

export default InputTextSearch;

const style = { width: '100%', minWidth: '290px' };
